import React from "react";
import MainImage from "../../assets/HeroImages/MainPot8.jpg";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import PastWork from "../../components/PastWord";
import About from "../../components/About";
import Testimony from "../../components/Testimony";

function AuthorityLaunchpad() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
      <title>Authority Launchpad™ | SEO-Focused Web Strategy for Experts | Her Growth Co.</title>
      <meta
        name="description"
        content="Our Launchpad program helps coaches and creatives develop an SEO-optimized web presence that converts and scales."
      />
      <meta
        name="keywords"
        content="all-in-one solution for experts, authority launch system, premium visibility package, brand strategy for high-level founders, expert digital foundation, launchpad for female entrepreneurs, web + SEO starter suite, scalable online authority system, web design and marketing austin, premium client attraction package, web services for premium consultants, high-ticket offer website funnel, all-in-one solution for experts, austin digital authority launchpad, niche domination digital package, entrepreneur website builder bundle, content + seo + design bundle, premium digital brand system texas, elite seo and branding solution, build online authority fast, amplify your brand voice, content marketing for coaches, thought leadership for consultants, visibility strategy for women-led brands, SEO + content for experts, digital power-up for founders, austin web design for women entrepreneurs, austin seo for female founders, website design for women-led businesses austin, custom websites for austin consultants, high-end website design austin, seo expert for women austin, premium branding austin women, austin digital authority launchpad, conversion-focused web design austin, web strategy for coaches austin, female entrepreneur seo services austin, austin cro expert services, all-in-one solution for experts, content marketing for women-led startups austin, seo for consultants in austin, website design agency austin tx, high-ticket client attraction austin, bespoke web design austin tx, online visibility for women founders, premium digital services austin, seo agency for women-owned business austin, women in business marketing austin, personal brand websites austin tx, social media + web strategy austin, website design for thought leaders austin"
      />

      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <Navbar />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 bg-[#CFF098] font-semibold">The Authority Launchpad</h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-6xl uppercase">
                Ready to Establish Your Expertise Online? Get a Website That Works as Hard as You Do.
              </h2>
              <p className="mb-8 mt-4 max-w-4xl text-base text-black md:mb-12 md:text-lg font-light">
                For ambitious <strong>women entrepreneurs</strong> ready to build a strong foundation and showcase their brilliance. Our Authority Launchpad package provides a <strong>professionally designed website</strong> to elevate your brand and credibility.
              </p>
            </div>

            {/* Benefits Grid Styled Like Services.jsx */}
            <div className="mt-12">
              <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4">
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">A Stunning, Up to 5-Page Website</h3>
                  <p className="text-black text-base font-light">
                    A beautiful, user-friendly website that showcases your services, tells your story, and makes it easy for potential clients to connect. Includes homepage, services, about, testimonials/case studies, and contact page.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Get Found Online with Foundational SEO</h3>
                  <p className="text-black text-base font-light">
                    We optimize your website for relevant keywords to help you rank locally and attract your ideal clients.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Seamless on Every Device</h3>
                  <p className="text-black text-base font-light">
                    Your website will be fully responsive, offering a flawless experience on mobile, tablet, and desktop.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Your Story, Beautifully Presented</h3>
                  <p className="text-black text-base font-light">
                    We help you refine or create content that speaks directly to your ideal clients and highlights your unique value.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Visually Engaging Design</h3>
                  <p className="text-black text-base font-light">
                    Access a curated library of professional, non-generic images that elevate your brand's visual identity.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Track Your Success</h3>
                  <p className="text-black text-base font-light">
                    We’ll install basic Google Analytics to help you start understanding your website performance.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="flex flex-col items-center justify-center mt-16">
              <a href="/contact" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">
                SCHEDULE YOUR FREE CONSULTATION
              </a>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                Empower Your Online Presence. Let's Build Your Authority Launchpad Today!
              </p>
            </div>
          </div>
        </section>
       
      
        <PastWork />
         <div className="bg-[#2E2D2B]">
<Testimony/>
         <About/>
         </div>
        <Footer />
      </section>
    </main>
  );
}

export default AuthorityLaunchpad;
